import { Helmet } from 'react-helmet-async';

import { Content } from './components/Content';

export const AttorneyViewFeatureFlags = () => {
  return (
    <>
      <Helmet>
        <title>AttorneyView Feature Flags - AutoScript Admin</title>
      </Helmet>
      <Content />
    </>
  );
};
